import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_INTERNAL_STORE_TRANSFER_STATE,
  defaultInternalStoreTransferState,
  FETCH_INTERNAL_STORE_TRANSFER_LIST_FAILED,
  FETCH_INTERNAL_STORE_TRANSFER_LIST_PROGRESS,
  FETCH_INTERNAL_STORE_TRANSFER_LIST_SUCCESS,
  InternalStoreTransferActions,
} from ".";

export const internalStoreTransferReducer = (
  state: IStoreState["internalStoreTransfer"] = defaultInternalStoreTransferState,
  action: InternalStoreTransferActions,
) => {
  switch (action.type) {
    case FETCH_INTERNAL_STORE_TRANSFER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.internal_store_transfer_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_INTERNAL_STORE_TRANSFER_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.internal_store_transfer_list.loading = LoadState.Loaded;
        draftState.internal_store_transfer_list.list = data;
        draftState.internal_store_transfer_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_INTERNAL_STORE_TRANSFER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.internal_store_transfer_list.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_INTERNAL_STORE_TRANSFER_STATE: {
      return defaultInternalStoreTransferState;
    }

    default: {
      return state;
    }
  }
};
